<template>
  <div class="export-dropdown-wrapper" @click.stop>
    <button
      @click="toggleDropdown"
      class="btn btn-primary d-flex align-items-center"
    >
      <feather-icon icon="DownloadIcon" class="mr-50" />
      <span class="text-nowrap">Export</span>
    </button>

    <!-- Dropdown menu -->
    <div v-if="dropdownOpen" class="export-dropdown-menu">
      <div class="dropdown-item" @click="exportFile('xlsx')">Export to Excel</div>
      <div class="dropdown-item" @click="exportFile('csv')">Export to CSV</div>
      <div class="dropdown-item" @click="exportFile('json')">Export to JSON</div>
      <div class="dropdown-item" @click="exportFile('imported')">Imported User CSV</div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import axios from 'axios'

export default {
  name: 'ExportExcelButtonimport',
  props: {
    data: {
      type: Array,
      required: true,
    },
    fileName: {
      type: String,
      default: 'export',
    },
    columns: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      dropdownOpen: false,
      apiUrl: 'https://geotalent-backend-production.up.railway.app/api/Users/Export',
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    closeDropdown() {
      this.dropdownOpen = false
    },

    async exportFile(type) {
      // ✅ 4th Option - Imported CSV from API
      if (type === 'imported') {
        try {
          const token = this.$store.state.userData.token
          const response = await axios.get(this.apiUrl, {
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
          })

          console.log('API Raw Response:', response.data)

          // ✅ Extract user data from response
          const apiData = response.data.users || []

          if (!apiData.length) {
            alert('No data received from API!')
            return
          }

          // ✅ Remove "id" field from each record
          const cleanedData = apiData.map(({ id, ...rest }) => rest)

          // Convert JSON → CSV
          const worksheet = XLSX.utils.json_to_sheet(cleanedData)
          const csv = XLSX.utils.sheet_to_csv(worksheet)
          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
          saveAs(blob, 'imported_users.csv')
        } catch (error) {
          console.error('Error exporting imported users:', error)
          alert('Failed to fetch data from API.')
        } finally {
          this.closeDropdown()
        }
        return
      }

      // ✅ Local Export (xlsx / csv / json)
      if (!this.data || !this.data.length) {
        alert('No data to export!')
        return
      }

      let keys =
        this.columns && this.columns.length
          ? this.columns
          : Object.keys(this.data[0])

      // ❌ Remove id column from export
      keys = keys.filter(k => k !== 'id')

      const exportData = this.data.map((item, index) => {
        const row = { '#': index + 1 }
        keys.forEach(key => {
          row[key] =
            item[key] !== null && item[key] !== undefined ? item[key] : ''
        })
        return row
      })

      if (type === 'xlsx') {
        const worksheet = XLSX.utils.json_to_sheet(exportData)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        })
        const blob = new Blob([excelBuffer], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        })
        saveAs(blob, `${this.fileName}.xlsx`)
      }

      if (type === 'csv') {
        const worksheet = XLSX.utils.json_to_sheet(exportData)
        const csv = XLSX.utils.sheet_to_csv(worksheet)
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        saveAs(blob, `${this.fileName}.csv`)
      }

      if (type === 'json') {
        const json = JSON.stringify(exportData, null, 2)
        const blob = new Blob([json], {
          type: 'application/json;charset=utf-8;',
        })
        saveAs(blob, `${this.fileName}.json`)
      }

      this.closeDropdown()
    },
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown)
  },
}
</script>

<style scoped>
.export-dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.export-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 160px;
  padding: 0.5rem 0;
  margin-top: 0.25rem;
  font-size: 14px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.dropdown-item {
  padding: 0.375rem 1rem;
  cursor: pointer;
  white-space: nowrap;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}
</style>
